const getConfig = () => {
  const APP_ID = process.env.VUE_APP_ID ?? 0

  const config = {
    // main
    "24": {
      deposit: {
        charge: {
          enabled: true,
          value: [
            { amount_max: 0, percent: 0 },
            { amount_max: 3000, percent: 0 }, //promotion
            { amount_max: 25000, percent: 0 }, //promotion
          ],
        },
        minimum_first_deposit: [
          { spec_id: `6932ba5f31a221bf5146aeaf`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `69205d8ccbe35874235df589`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68f48559a30c11af641652c0`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68ee323841f5c19ccc3ac88f`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68ec87221dc3af46840bbf04`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68998ee343a70495de6ecabc`, name: `Prime`, type: `REAL`, min: 10 },
          { spec_id: `6895a58355b7afef96e7bfda`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `6895a4cf55b7afef96e7bfd0`, name: `PAMM-Manager`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `6893225854bab85641bbbd78`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `686221edf21df7a95082ecb4`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `6833fe857a5b816858c3fc19`, name: `PAMM-Manager`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `680884a196fb51403b9d0115`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `67e0fb302733514540b64a19`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `67c6c306927e08e198174d09`, name: `PAMM-Manager-Test`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `6772c8ad4ab1a10c3c01a4d2`, name: `Preliminary ECN`, type: `REAL`, min: 100 },
          { spec_id: `67614156caead817c7bc69c3`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `66aa5d5be33a53ff1d6f3f18`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `6687c2b6288d3e074ac4834d`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `663c37641ed09022b8d9a09e`, name: `Advanced Account`, type: `REAL`, min: 10 },
          { spec_id: `66050513154023392108b8a9`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `6601629efaac1e0921459b80`, name: `PAMM-Manager`, type: `REAL`, min: 10 },
          { spec_id: `659f67b76c44d3bcd974c4e1`, name: `Institutional Account`, type: `REAL`, min: 10 },
          { spec_id: `6513c9bcb31cd670e7530b92`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `65001de496ea88b4f64f48d6`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `65001d9fa0fdf0dfc31078ca`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `63d8ef6075546f258b9be41f`, name: `Corpus`, type: `REAL`, min: 10 },
          { spec_id: `63d426418d4ffd749e75d5eb`, name: `PAMM-Manager`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `63a29f82c1c89b2ef5695d00`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `638ee0d3d9333b1ab970f78e`, name: `Standard Account Centurion`, type: `REAL`, min: 10 },
          { spec_id: `634fdc9e44915b65b0f9f08d`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `634fd67879d1756540c20a12`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `634faaaecf2a80752dc0d23a`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `63245e3133942b5820339cd9`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `630c6ef7a71b462d4b9c16bb`, name: `Prime 2`, type: `REAL`, min: 10 },
          { spec_id: `6251429be664fc247cd05b63`, name: `Fortune Account`, type: `REAL`, min: 10 },
          { spec_id: `620b323e7d44f04b4e81b319`, name: `Prime`, type: `REAL`, min: 10 },
          { spec_id: `61dc3f85ca34a745b09ca926`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `61237a1e0a9adb5d230002d3`, name: `US Stocks Account`, type: `REAL`, min: 10 },
          { spec_id: `60d876815978e030100d72fb`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `60d8766c5978e030100d72fa`, name: `ECN Account`, type: `REAL`, min: 100 },
        ],
        minimum_topup: 10,
        crypto: [
          {
            enabled: true,
            network: `ERC20`,
            address: `0xAb7b2cFC91493d8C87D20b09f5A0963DF6E4973F`,
            img: `/assets/img/address-main/crypto-erc20.jpg`,
          },
          {
            enabled: true,
            network: `TRC20`,
            address: `TCS1XV1XHAey9WSEhDMGQNEEpf1fNGBdp8`,
            img: `/assets/img/address-main/crypto-trc20.jpg`,
          },
          {
            enabled: true,
            network: `BEP20`,
            address: `0x80b4B5728df2daFdf541252261A42878e9f7e110`,
            img: `/assets/img/address-main/crypto-bep20.jpg`,
          },
        ],
        bank: {
          enabled: true,
          bank_name: `Emirates NBD`,
          account_number: `1015798536201`,
          account_name: `PRIME CODEX FUTURE COMMERCIAL BROKERS`,
          beneficiary_address: `Dubai`,
          branch_address: `Dubai`,
          bank_address: `UAE`,
          iban_code: `AE880260001015798536201`,
          swift_code: `EBILAEAD`,
          disclaimer: {
            show: true,
            html: `  <p>
                 Please be advised that deposit are processed within approximately 1–3 business days. For any inquiries or assistance, kindly contact us at <a href="mailto:support@primecodex.com">support@primecodex.com</a>.
                </p>`,
          },
        },
        disclaimer: {
          show: true,
          // html: `
          //     <h5><b>Important note on deposit fees:</b></h5>
          //     There is a charge if you do the deposit via USDT wallet as you see on your request deposit,
          //     <ul style="margin: 0 0 0 0px;">
          //     <li>1.5% for $0 - $2,999</li>
          //     <li>0.5% for $3,000 - $24,999</li>
          //     <li>$25,000 or more is Free</li>
          //     </ul>
          //   `,
          html: `
              <h6><b>0% Crypto Deposit Fee</b></h6>
              We don’t charge any fee for crypto deposits.
              You’ll only pay the <b>network gas fee</b> required to process the transaction.
              `,
        },
        unique_code_disclaimer:{
          show: true,
          html: `
              Your deposit includes a small unique <b>code</b> for secure and faster processing. This code is for <b>identification only</b> and will be credited to your account together with your deposit.
          `,
        },
        maintenance_notice: {
          show: false,
          title_alert:  `Attention`,
          message_alert: `
            "Our server currently undergo maintenance. During this time, we suggest holding off on any MetaTrader-related requests.`,
          icon_alert: `warning`,
          message_notice_html: `
            <p>
            We want to let you know that our LD MetaTrader server will undergo
            maintenance on Saturday, June 22nd 2024 | 01:00 - 24:00 BST. During
            this time, we suggest holding off on any MetaTrader-related requests.
            This maintenance is important to keep our service running smoothly and
            to provide you with the best experience possible.
            </p>
        `,
        },
        paymentMethods: {
          methods: [
            {
              show: true,
              name: `Crypto USDT`,
              network: `TRC20`,
              fee: `0% - 1.5%`, 
              limits: `$10 USD`,
              recommended: true,
              icon: `/assets/img/icon/tron.png`,
              url: { path: `/deposit-crypto`, query: { network: `TRC20` } },
            },
            {
              show: true,
              name: `Crypto USDT`,
              network: `ERC20`,
              fee: `0% - 1.5%`,
              limits: `$10 USD`,
              recommended: true,
              icon: `/assets/img/icon/eth.png`,
              url: { path: `/deposit-crypto`, query: { network: `ERC20` } },
            },
            {
              show: true,
              name: `Crypto USDT`,
              network: `BEP20`,
              fee: `0% - 1.5%`,
              limits: `$10 USD`,
              recommended: true,
              icon: `/assets/img/icon/binance.png`,
              url: { path: `/deposit-crypto`, query: { network: `BEP20` } },
            },
            {
              show: false,
              name: `Wire Transfer`,
              network: `Bank Transfer`,
              fee: `Depend on your Bank`,
              limits: `$1000 USD`,
              recommended: false,
              icon: `/assets/img/icon/wire-bank.png`,
              url: { path: `/deposit-wire`, query: { network: `Bank Transfer` } },
            },
          ],
        },
      },
      withdraw: {
        bank: {
          enabled: true,
          bank_name: `Emirates NBD`,
          account_number: `1015798536201`,
          account_name: `PRIME CODEX FUTURE COMMERCIAL BROKERS`,
          beneficiary_address: `Dubai`,
          branch_address: `Dubai`,
          bank_address: `UAE`,
          iban_code: `AE880260001015798536201`,
          swift_code: `EBILAEAD`,
          disclaimer: {
            show: true,
            html: `  <p>
                 Please be advised that withdrawal are processed within approximately 1–3 business days. For any inquiries or assistance, kindly contact us at <a href="mailto:support@primecodex.com">support@primecodex.com</a>.
                </p>`,
          },
        },
        tnc: {
          show: true,
          html: `
             <div class="border-bottom-mobile">
            We want to inform you of the terms and conditions regarding withdrawal
            from your trading account. Please read the following information
            carefully to ensure a smooth and efficient withdrawal process.
            </div>
              <section class="scrollable">
              <ol>
                <li>
                  Withdrawal requests submitted
                  <b style="color: #00a804">before 02:00 PM UTC</b> will be processed
                  on the same day. Requests made
                  <b style="color: #00a804">after 02:00 PM UTC</b> will be processed
                  on the next business hour.
                </li>
                <li>
                  The withdrawal amount should be less than or equal to the
                  <b style="color: #00a804">account balance</b>
                  when the withdrawal being is requested.
                </li>
                <li>
                  A minimum of
                  <b style="color: #00a804">125% free margin</b> must be available in
                  your trading account to process the withdrawal request to anticipate
                  your trading account to a margin call.
                </li>
                <li>
                  Funds will be transferred to the bank account in a similar name as
                  your <b style="color: #00a804">trading account</b>.
                </li>
                <li>
                  Several conditions cause your withdrawal to be
                  <b style="color: #00a804">processed 2x24 hours</b>
                  during business hours. These conditions include:
                  <ul>
                    <li>
                      <span style="color: black"
                        ><b style="color: #00a804">Withdrawing all of the balance</b>
                        on your real trading account.</span
                      >
                    </li>
                    <li>
                      <span style="color: black"
                        ><b style="color: #00a804">Withdrawing 90% of your balance</b>
                        on your real trading account.</span
                      >
                    </li>
                    <li>
                      <span style="color: black">
                        <b style="color: #00a804">Withdrawing over $2,500.00</b>
                        per week from one account in a single request or multiple
                        requests made through the same user interface or platform.
                      </span>
                    </li>
                  </ul>
                  This could happen due to our policy requiring us to withdraw from
                  our Liquidity Provider.
                </li>
              </ol>
              Thank you for your attention to these terms and conditions. We
              appreciate your business and are committed to providing you with a
              seamless and satisfactory trading experience.
            </section>
          `,
        },
        disclaimer: {
          show: true,
          // html: `
          //     <h5><b>Important note on withdrawal fees:</b></h5>
          //     A fee will be charged based on the total amount withdrawn. Withdrawal fee percentages are as follows:
          //     <ul style="margin: 0 0 0 0px;">
          //     <li>1.5% for $0 - $2,499.99</li>
          //     <li>1% for $2,500 - $19,999.99</li>
          //     <li>0.75% for $20,000 or more</li>
          //     </ul>
          //     <br />
          //     Please note that <b>gas fees are not included</b> and will be the client's responsibility.
          //     <br />
          //     Clients are responsible for paying the withdrawal and gas fees.
          //   `,
          html: `
                  <h6><b>0% Crypto Withdrawal Fee</b></h6>
                  We don’t charge any fee for crypto withdrawals.
                  You’ll only pay the <b>network gas fee</b> required to process the transaction.

          `,
        },
        useVerifyPoA: true,
        paymentMethods: {
          methods: [
            {
              show: true,
              name: `Crypto USDT`,
              network: `TRC20`,
              fee: `0.75% - 1.5%`, //unused during promotion 
              limits: `$10 USD`,
              recommended: true,
              icon: `/assets/img/icon/tron.png`,
              url: { path: `/withdraw-crypto`, query: { network: `TRC20` } },
            },
            {
              show: true,
              name: `Crypto USDT`,
              network: `ERC20`,
              fee: `0.75% - 1.5%`,//unused during promotion 
              limits: `$10 USD`,
              recommended: true,
              icon: `/assets/img/icon/eth.png`,
              url: { path: `/withdraw-crypto`, query: { network: `ERC20` } },
            },
            {
              show: true,
              name: `Crypto USDT`,
              network: `BEP20`,
              fee: `0.75% - 1.5%`,//unused during promotion 
              limits: `$10 USD`,
              recommended: true,
              icon: `/assets/img/icon/binance.png`,
              url: { path: `/withdraw-crypto`, query: { network: `BEP20` } },
            },
            {
              show: false,
              name: `Wire Transfer`,
              network: `Bank Transfer`,
              fee: `Depend on your Bank`,
              limits: `$1000 USD`,
              recommended: false,
              icon: `/assets/img/icon/wire-bank.png`,
              url: { path: `/withdraw-wire`, query: { network: `Bank Transfer` } },
            },
          ],
        },
        minimum_withdraw: [
          { spec_id: `6932ba5f31a221bf5146aeaf`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `69205d8ccbe35874235df589`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68f48559a30c11af641652c0`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68ee323841f5c19ccc3ac88f`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68ec87221dc3af46840bbf04`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `68998ee343a70495de6ecabc`, name: `Prime`, type: `REAL`, min: 10 },
          { spec_id: `6895a58355b7afef96e7bfda`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `6895a4cf55b7afef96e7bfd0`, name: `PAMM-Manager`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `6893225854bab85641bbbd78`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `686221edf21df7a95082ecb4`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `6833fe857a5b816858c3fc19`, name: `PAMM-Manager`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `680884a196fb51403b9d0115`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `67e0fb302733514540b64a19`, name: `Gold Futures Account`, type: `REAL`, min: 10 },
          { spec_id: `67c6c306927e08e198174d09`, name: `PAMM-Manager-Test`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `6772c8ad4ab1a10c3c01a4d2`, name: `Preliminary ECN`, type: `REAL`, min: 100 },
          { spec_id: `67614156caead817c7bc69c3`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `66aa5d5be33a53ff1d6f3f18`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `6687c2b6288d3e074ac4834d`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `663c37641ed09022b8d9a09e`, name: `Advanced Account`, type: `REAL`, min: 10 },
          { spec_id: `66050513154023392108b8a9`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `6601629efaac1e0921459b80`, name: `PAMM-Manager`, type: `REAL`, min: 10 },
          { spec_id: `659f67b76c44d3bcd974c4e1`, name: `Institutional Account`, type: `REAL`, min: 10 },
          { spec_id: `6513c9bcb31cd670e7530b92`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `65001de496ea88b4f64f48d6`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `65001d9fa0fdf0dfc31078ca`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `63d8ef6075546f258b9be41f`, name: `Corpus`, type: `REAL`, min: 10 },
          { spec_id: `63d426418d4ffd749e75d5eb`, name: `PAMM-Manager`, type: `PAMM_MANAGER`, min: 10 },
          { spec_id: `63a29f82c1c89b2ef5695d00`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `638ee0d3d9333b1ab970f78e`, name: `Standard Account Centurion`, type: `REAL`, min: 10 },
          { spec_id: `634fdc9e44915b65b0f9f08d`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `634fd67879d1756540c20a12`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `634faaaecf2a80752dc0d23a`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `63245e3133942b5820339cd9`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `630c6ef7a71b462d4b9c16bb`, name: `Prime 2`, type: `REAL`, min: 10 },
          { spec_id: `6251429be664fc247cd05b63`, name: `Fortune Account`, type: `REAL`, min: 10 },
          { spec_id: `620b323e7d44f04b4e81b319`, name: `Prime`, type: `REAL`, min: 10 },
          { spec_id: `61dc3f85ca34a745b09ca926`, name: `ECN Account`, type: `REAL`, min: 100 },
          { spec_id: `61237a1e0a9adb5d230002d3`, name: `US Stocks Account`, type: `REAL`, min: 10 },
          { spec_id: `60d876815978e030100d72fb`, name: `Standard Account`, type: `REAL`, min: 10 },
          { spec_id: `60d8766c5978e030100d72fa`, name: `ECN Account`, type: `REAL`, min: 100 },
        ],
      },
      zendesk: {
        enabled: true,
        link: `https://static.zdassets.com/ekr/snippet.js?key=7cae1107-ba75-4157-9df5-330a33e42e4e`,
        widget: `https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=supportprimecodex.zendesk.com&settings=JTdCJTIyd2ViV2lkZ2V0JTIyJTNBJTdCJTIyY2hhdCUyMiUzQSU3QiUyMnRpdGxlJTIyJTNBbnVsbCUyQyUyMm1lbnVPcHRpb25zJTIyJTNBJTdCJTIyZW1haWxUcmFuc2NyaXB0JTIyJTNBdHJ1ZSU3RCUyQyUyMmRlcGFydG1lbnRzJTIyJTNBJTdCJTdEJTJDJTIycHJlY2hhdEZvcm0lMjIlM0ElN0IlMjJkZXBhcnRtZW50TGFiZWwlMjIlM0FudWxsJTJDJTIyZ3JlZXRpbmclMjIlM0FudWxsJTdEJTJDJTIyb2ZmbGluZUZvcm0lMjIlM0ElN0IlMjJncmVldGluZyUyMiUzQW51bGwlN0QlMkMlMjJjb25jaWVyZ2UlMjIlM0ElN0IlMjJhdmF0YXJQYXRoJTIyJTNBbnVsbCUyQyUyMm5hbWUlMjIlM0FudWxsJTJDJTIydGl0bGUlMjIlM0FudWxsJTdEJTdEJTJDJTIyY29sb3IlMjIlM0ElN0IlMjJhcnRpY2xlTGlua3MlMjIlM0ElMjIlMjIlMkMlMjJidXR0b24lMjIlM0ElMjIlMjIlMkMlMjJoZWFkZXIlMjIlM0ElMjIlMjIlMkMlMjJsYXVuY2hlciUyMiUzQSUyMiUyMiUyQyUyMmxhdW5jaGVyVGV4dCUyMiUzQSUyMiUyMiUyQyUyMnJlc3VsdExpc3RzJTIyJTNBJTIyJTIyJTJDJTIydGhlbWUlMjIlM0FudWxsJTdEJTdEJTdE&mid=&locale=en-us&title=Web%20Widget%20Live%20Chat`,
      },
      register_url: `https://primecodex.com/register`,
      spec_account: {
        standard: `60d876815978e030100d72fb`,
        ecn: `60d8766c5978e030100d72fa`,
        usstock: `61237a1e0a9adb5d230002d3`,
        institutional: `659f67b76c44d3bcd974c4e1`,
        demo: `60d356dd26b7e058ec061ca9`,
        invlinic: `663c37641ed09022b8d9a09e`,
      },
    },
    // olah
    "244": {
      deposit: {
        charge: {
          enabled: true,
          value: [
            { amount_max: 0, percent: 0 },
            { amount_max: 3000, percent: 1.5 },
            { amount_max: 25000, percent: 0.5 },
          ],
        },
        crypto: [
          {
            enabled: false,
            network: `ERC20`,
            address: `-`,
            img: `-`,
          },
          {
            enabled: true,
            network: `TRC20`,
            address: `TD64bju41ZigmFQoTvauxEHTfCyUvsexpH`,
            img: `/assets/img/address-olah/crypto-trc20.jpg`,
          },
        ],
        bank: {
          enabled: false,
          bank_name: `Emirates NBD`,
          account_number: `1015798536201`,
          account_name: `PRIME CODEX FUTURE COMMERCIAL BROKERS`,
          beneficiary_address: `Dubai`,
          branch_address: `Dubai`,
          bank_address: `UAE`,
          iban_code: `AE880260001015798536201`,
          swift_code: `EBILAEAD`,
          disclaimer: {
            show: false,
            html: `  <p>
                 Please be advised that a deposit fee will be charged directly to the client, processing will take approximately 1–3 business days, and for any questions or support, feel free to contact us at  <a href="mailto:support@primecodex.com">support@primecodex.com</a>.
                </p>`,
          },
        },
        disclaimer: {
          show: true,
          html: `
              <h5><b>Important note on deposit fees:</b></h5>
              There is a charge if you do the deposit via USDT wallet as you see on your request deposit,
              <br />
              1.5% for $0 - $2,999
              <br />
              0.5% for $3,000 - $24,999
              <br />
              $25,000 or more is Free
            `,
        },
        unique_code_disclaimer:{
          show: true,
          html: `
              Your deposit includes a small unique <b>code</b> for secure and faster processing. This code is for <b>identification only</b> and does not impact the amount credited to your account.
          `,
        },
        maintenance_notice: {
          show: false,
          title_alert:  `Attention`,
          message_alert: `
            "Our server currently undergo maintenance. During this time, we suggest holding off on any MetaTrader-related requests.`,
          icon_alert: `warning`,
          message_notice_html: `
            <p>
            We want to let you know that our LD MetaTrader server will undergo
            maintenance on Saturday, June 22nd 2024 | 01:00 - 24:00 BST. During
            this time, we suggest holding off on any MetaTrader-related requests.
            This maintenance is important to keep our service running smoothly and
            to provide you with the best experience possible.
            </p>
        `,
        },
        paymentMethods: {
          methods: [
            {
              show: true,
              name: `Crypto USDT`,
              network: `TRC20`,
              fee: `0% - 1.5%`, 
              limits: `$1 USD`,
              recommended: false,
              icon: `/assets/img/icon/tron.png`,
              url: { path: `/deposit-crypto`, query: { network: `TRC20` } },
            },
            {
              show: false,
              name: `Crypto USDT`,
              network: `ERC20`,
              fee: `0% - 1.5%`,
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/eth.png`,
              url: { path: `/deposit-crypto`, query: { network: `ERC20` } },
            },
            {
              show: false,
              name: `Wire Transfer`,
              network: `Bank Transfer`,
              fee: `Depend on your Bank`,
              limits: `$1000 USD`,
              recommended: false,
              icon: `/assets/img/icon/wire-bank.png`,
              url: `/deposit-wire`,
            },
          ],
        },
      },
      withdraw: {
        bank: {
          enabled: true,
          bank_name: `Emirates NBD`,
          account_number: `1015798536201`,
          account_name: `PRIME CODEX FUTURE COMMERCIAL BROKERS`,
          beneficiary_address: `Dubai`,
          branch_address: `Dubai`,
          bank_address: `UAE`,
          iban_code: `AE880260001015798536201`,
          swift_code: `EBILAEAD`,
          disclaimer: {
            show: true,
            html: `  <p>
                 Please be advised that withdrawal are processed within approximately 1–3 business days. For any inquiries or assistance, kindly contact us at <a href="mailto:support@primecodex.com">support@primecodex.com</a>.
                </p>`,
          },
        },
        tnc: {
          show: true,
          html: `
          <div class="border-bottom-mobile">
          We want to inform you of the terms and conditions regarding withdrawal from your trading account. Please read the following information carefully to ensure a smooth and efficient withdrawal process.
          </div>
            <section class="scrollable">
              <ol>
                <li>
                  Withdrawal requests submitted
                  <b style="color: #00a804">before 02:00 PM UTC</b> will be processed on the same day. Requests made <b style="color: #00a804">after 02:00 PM UTC</b> will be processed on the next business hour.
                </li>
                <li>
                  The withdrawal amount should be less than or equal to the
                  <b style="color: #00a804">account balance</b>
                  when the withdrawal being is requested.
                </li>
                <li>
                  A minimum of
                  <b style="color: #00a804">125% free margin</b> must be available in your trading account to process the withdrawal request to anticipate your trading account to a margin call.
                </li>
                <li>Funds will be transferred to the bank account in a similar name as your <b style="color: #00a804">trading account</b>.</li>
                <li>
                  Several conditions cause your withdrawal to be
                  <b style="color: #00a804">processed 2x24 hours</b>
                  during business hours. These conditions include:
                  <ul>
                    <li>
                      <span style="color: black"><b style="color: #00a804">Withdrawing all of the balance</b> on your real trading account.</span>
                    </li>
                    <li>
                      <span style="color: black"><b style="color: #00a804">Withdrawing 90% of your balance</b> on your real trading account.</span>
                    </li>
                    <li>
                      <span style="color: black">
                        <b style="color: #00a804">Withdrawing over $2,500.00</b>
                        per week from one account in a single request or multiple requests made through the same user interface or platform.
                      </span>
                    </li>
                  </ul>
                  This could happen due to our policy requiring us to withdraw from our Liquidity Provider.
                </li>
              </ol>
              Thank you for your attention to these terms and conditions. We appreciate your business and are committed to providing you with a seamless and satisfactory trading experience.
            </section>
          `,
        },
        disclaimer: {
          show: false,
          html: `
            Withdrawal request cut off time 12:00 AEST/AEDT. Withdrawal submitted before this time will be processed same day, requests made after will be processed next business day.
            <br>
            The requested withdrawal amount should be less than or equal to the account balance at the time of the processing of your withdrawal request.
            <br>
            There should be at least 100% free margin available in your trade account. This requirement is in place to reduce the likelihood of a margin call.
            `,
        },
        useVerifyPoA: true,
        paymentMethods: {
          methods: [
            {
              show: true,
              name: `Crypto USDT`,
              network: `TRC20`,
              fee: `0.75% - 1.5%`, 
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/tron.png`,
              url: { path: `/withdraw-crypto`, query: { network: `TRC20` } },
            },
            {
              show: false,
              name: `Crypto USDT`,
              network: `ERC20`,
              fee: `0.75% - 1.5%`,
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/eth.png`,
              url: { path: `/withdraw-crypto`, query: { network: `ERC20` } },
            },
            {
              show: false,
              name: `Wire Transfer`,
              network: `Bank Transfer`,
              fee: `Depend on your Bank`,
              limits: `$1000 USD`,
              recommended: false,
              icon: `/assets/img/icon/wire-bank.png`,
              url: { path: `/withdraw-wire`, query: { network: `Bank Transfer` } },
            },
          ],
        },
      },
      zendesk: {
        enabled: true,
        link: `https://static.zdassets.com/ekr/snippet.js?key=7cae1107-ba75-4157-9df5-330a33e42e4e`,
        widget: `https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=supportprimecodex.zendesk.com&settings=JTdCJTIyd2ViV2lkZ2V0JTIyJTNBJTdCJTIyY2hhdCUyMiUzQSU3QiUyMnRpdGxlJTIyJTNBbnVsbCUyQyUyMm1lbnVPcHRpb25zJTIyJTNBJTdCJTIyZW1haWxUcmFuc2NyaXB0JTIyJTNBdHJ1ZSU3RCUyQyUyMmRlcGFydG1lbnRzJTIyJTNBJTdCJTdEJTJDJTIycHJlY2hhdEZvcm0lMjIlM0ElN0IlMjJkZXBhcnRtZW50TGFiZWwlMjIlM0FudWxsJTJDJTIyZ3JlZXRpbmclMjIlM0FudWxsJTdEJTJDJTIyb2ZmbGluZUZvcm0lMjIlM0ElN0IlMjJncmVldGluZyUyMiUzQW51bGwlN0QlMkMlMjJjb25jaWVyZ2UlMjIlM0ElN0IlMjJhdmF0YXJQYXRoJTIyJTNBbnVsbCUyQyUyMm5hbWUlMjIlM0FudWxsJTJDJTIydGl0bGUlMjIlM0FudWxsJTdEJTdEJTJDJTIyY29sb3IlMjIlM0ElN0IlMjJhcnRpY2xlTGlua3MlMjIlM0ElMjIlMjIlMkMlMjJidXR0b24lMjIlM0ElMjIlMjIlMkMlMjJoZWFkZXIlMjIlM0ElMjIlMjIlMkMlMjJsYXVuY2hlciUyMiUzQSUyMiUyMiUyQyUyMmxhdW5jaGVyVGV4dCUyMiUzQSUyMiUyMiUyQyUyMnJlc3VsdExpc3RzJTIyJTNBJTIyJTIyJTJDJTIydGhlbWUlMjIlM0FudWxsJTdEJTdEJTdE&mid=&locale=en-us&title=Web%20Widget%20Live%20Chat`,
      },
      register_url: `https://olah.primecodex.com/register`,
      spec_account: {
        standard: `677f8b62d730e9627826a928`,
        ecn: `677f8b39d730e9627826a920`,
        usstock: null,
        institutional: null,
        demo: `677f8744d730e9627826a89c`,
        invlinic: null,
      },
    },
    // bee
    "243": {
      deposit: {
        charge: {
          enabled: false,
          value: [
            { amount_max: 0, percent: 0 },
            { amount_max: 3000, percent: 1.5 },
            { amount_max: 25000, percent: 0.5 },
          ],
        },
        crypto: [
          {
            enabled: true,
            network: `ERC20`,
            address: `0x977BF6621E18C52CFd67Ae06b4e9d77ba022aa41`,
            img: `/assets/img/address-beetrade/crypto-erc20.jpg`,
          },
          {
            enabled: true,
            network: `TRC20`,
            address: `TR8VddCFpNYBmQUrgecEYxGuZCYLNwoDaE`,
            img: `/assets/img/address-beetrade/crypto-trc20.jpg`,
          },
        ],
        bank: {
          enabled: false,
          bank_name: `Emirates NBD`,
          account_number: `1015798536201`,
          account_name: `PRIME CODEX FUTURE COMMERCIAL BROKERS`,
          beneficiary_address: `Dubai`,
          branch_address: `Dubai`,
          bank_address: `UAE`,
          iban_code: `AE880260001015798536201`,
          swift_code: `EBILAEAD`,
          disclaimer: {
            show: false,
            html: `  <p>
                 Please be advised that a deposit fee will be charged directly to the client, processing will take approximately 1–3 business days, and for any questions or support, feel free to contact us at  <a href="mailto:support@primecodex.com">support@primecodex.com</a>.
                </p>`,
          },
        },
        disclaimer: {
          show: false,
          html: `
              <h5><b>Important note on deposit fees:</b></h5>
              There is a charge if you do the deposit via USDT wallet as you see on your request deposit,
              <br />
              1.5% for $0 - $2,999
              <br />
              0.5% for $3,000 - $24,999
              <br />
              $25,000 or more is Free
            `,
        },
        unique_code_disclaimer:{
          show: false,
          html: `
              Your deposit includes a small unique <b>code</b> for secure and faster processing. This code is for <b>identification only</b> and does not impact the amount credited to your account.
          `,
        },
        maintenance_notice: {
          show: false,
          title_alert:  `Attention`,
          message_alert: `
            "Our server currently undergo maintenance. During this time, we suggest holding off on any MetaTrader-related requests.`,
          icon_alert: `warning`,
          message_notice_html: `
            <p>
            We want to let you know that our LD MetaTrader server will undergo
            maintenance on Saturday, June 22nd 2024 | 01:00 - 24:00 BST. During
            this time, we suggest holding off on any MetaTrader-related requests.
            This maintenance is important to keep our service running smoothly and
            to provide you with the best experience possible.
            </p>
        `,
        },
        paymentMethods: {
          methods: [
            {
              show: true,
              name: `Crypto USDT`,
              network: `TRC20`,
              fee: `0% - 1.5%`, 
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/tron.png`,
              url: { path: `/deposit-crypto`, query: { network: `TRC20` } },
            },
            {
              show: true,
              name: `Crypto USDT`,
              network: `ERC20`,
              fee: `0% - 1.5%`,
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/eth.png`,
              url: { path: `/deposit-crypto`, query: { network: `ERC20` } },
            },
            {
              show: false,
              name: `Wire Transfer`,
              network: `Bank Transfer`,
              fee: `Depend on your Bank`,
              limits: `$1000 USD`,
              recommended: false,
              icon: `/assets/img/icon/wire-bank.png`,
              url: `/deposit-wire`,
            },
          ],
        },
      },
      withdraw: {
        bank: {
          enabled: false,
          bank_name: `Emirates NBD`,
          account_number: `1015798536201`,
          account_name: `PRIME CODEX FUTURE COMMERCIAL BROKERS`,
          beneficiary_address: `Dubai`,
          branch_address: `Dubai`,
          bank_address: `UAE`,
          iban_code: `AE880260001015798536201`,
          swift_code: `EBILAEAD`,
          disclaimer: {
            show: false,
            html: `  <p>
                 Please be advised that withdrawal are processed within approximately 1–3 business days. For any inquiries or assistance, kindly contact us at <a href="mailto:support@primecodex.com">support@primecodex.com</a>.
                </p>`,
          },
        },
        tnc: {
          show: true,
          html: `
             <div class="border-bottom-mobile">
            We want to inform you of the terms and conditions regarding withdrawal
            from your trading account. Please read the following information
            carefully to ensure a smooth and efficient withdrawal process.
            </div>
              <section class="scrollable">
              <ol>
                <li>
                  Withdrawal requests submitted
                  <b style="color: #00a804">before 02:00 PM UTC</b> will be processed
                  on the same day. Requests made
                  <b style="color: #00a804">after 02:00 PM UTC</b> will be processed
                  on the next business hour.
                </li>
                <li>
                  The withdrawal amount should be less than or equal to the
                  <b style="color: #00a804">account balance</b>
                  when the withdrawal being is requested.
                </li>
                <li>
                  A minimum of
                  <b style="color: #00a804">125% free margin</b> must be available in
                  your trading account to process the withdrawal request to anticipate
                  your trading account to a margin call.
                </li>
                <li>
                  Funds will be transferred to the bank account in a similar name as
                  your <b style="color: #00a804">trading account</b>.
                </li>
                <li>
                  Several conditions cause your withdrawal to be
                  <b style="color: #00a804">processed 2x24 hours</b>
                  during business hours. These conditions include:
                  <ul>
                    <li>
                      <span style="color: black"
                        ><b style="color: #00a804">Withdrawing all of the balance</b>
                        on your real trading account.</span
                      >
                    </li>
                    <li>
                      <span style="color: black"
                        ><b style="color: #00a804">Withdrawing 90% of your balance</b>
                        on your real trading account.</span
                      >
                    </li>
                    <li>
                      <span style="color: black">
                        <b style="color: #00a804">Withdrawing over $2,500.00</b>
                        per week from one account in a single request or multiple
                        requests made through the same user interface or platform.
                      </span>
                    </li>
                  </ul>
                  This could happen due to our policy requiring us to withdraw from
                  our Liquidity Provider.
                </li>
              </ol>
              Thank you for your attention to these terms and conditions. We
              appreciate your business and are committed to providing you with a
              seamless and satisfactory trading experience.
            </section>
          `,
        },
        disclaimer: {
          show: true,
          html: `
              <h5><b>Important note on withdrawal fees:</b></h5>
              A fee will be charged based on the total amount withdrawn. Withdrawal fee percentages are as follows:
              <ul style="margin: 0 0 0 0px;">
              <li>1.5% for $0 - $2,499.99</li>
              <li>1% for $2,500 - $19,999.99</li>
              <li>0.75% for $20,000 or more</li>
              </ul>
              <br />
              Please note that <b>gas fees are not included</b> and will be the client's responsibility.
              <br />
              Clients are responsible for paying the withdrawal and gas fees.
            `,
        },
        useVerifyPoA: true,
        paymentMethods: {
          methods: [
            {
              show: true,
              name: `Crypto USDT`,
              network: `TRC20`,
              fee: `0.75% - 1.5%`, 
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/tron.png`,
              url: { path: `/withdraw-crypto`, query: { network: `TRC20` } },
            },
            {
              show: true,
              name: `Crypto USDT`,
              network: `ERC20`,
              fee: `0.75% - 1.5%`,
              limits: `$1 USD`,
              recommended: true,
              icon: `/assets/img/icon/eth.png`,
              url: { path: `/withdraw-crypto`, query: { network: `ERC20` } },
            },
            {
              show: false,
              name: `Wire Transfer`,
              network: `Bank Transfer`,
              fee: `Depend on your Bank`,
              limits: `$1000 USD`,
              recommended: false,
              icon: `/assets/img/icon/wire-bank.png`,
              url: { path: `/withdraw-wire`, query: { network: `Bank Transfer` } },
            },
          ],
        },
      },
      zendesk: {
        enabled: true,
        link: `https://static.zdassets.com/ekr/snippet.js?key=7cae1107-ba75-4157-9df5-330a33e42e4e`,
        widget: `https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=supportprimecodex.zendesk.com&settings=JTdCJTIyd2ViV2lkZ2V0JTIyJTNBJTdCJTIyY2hhdCUyMiUzQSU3QiUyMnRpdGxlJTIyJTNBbnVsbCUyQyUyMm1lbnVPcHRpb25zJTIyJTNBJTdCJTIyZW1haWxUcmFuc2NyaXB0JTIyJTNBdHJ1ZSU3RCUyQyUyMmRlcGFydG1lbnRzJTIyJTNBJTdCJTdEJTJDJTIycHJlY2hhdEZvcm0lMjIlM0ElN0IlMjJkZXBhcnRtZW50TGFiZWwlMjIlM0FudWxsJTJDJTIyZ3JlZXRpbmclMjIlM0FudWxsJTdEJTJDJTIyb2ZmbGluZUZvcm0lMjIlM0ElN0IlMjJncmVldGluZyUyMiUzQW51bGwlN0QlMkMlMjJjb25jaWVyZ2UlMjIlM0ElN0IlMjJhdmF0YXJQYXRoJTIyJTNBbnVsbCUyQyUyMm5hbWUlMjIlM0FudWxsJTJDJTIydGl0bGUlMjIlM0FudWxsJTdEJTdEJTJDJTIyY29sb3IlMjIlM0ElN0IlMjJhcnRpY2xlTGlua3MlMjIlM0ElMjIlMjIlMkMlMjJidXR0b24lMjIlM0ElMjIlMjIlMkMlMjJoZWFkZXIlMjIlM0ElMjIlMjIlMkMlMjJsYXVuY2hlciUyMiUzQSUyMiUyMiUyQyUyMmxhdW5jaGVyVGV4dCUyMiUzQSUyMiUyMiUyQyUyMnJlc3VsdExpc3RzJTIyJTNBJTIyJTIyJTJDJTIydGhlbWUlMjIlM0FudWxsJTdEJTdEJTdE&mid=&locale=en-us&title=Web%20Widget%20Live%20Chat`,
      },
      register_url: `https://beetrade.primecodex.com/register`,
      spec_account: {
        standard: `60d876815978e030100d72fb`,
        ecn: `6721e7efa3ae72825f1f9fa6`,
        usstock: `61237a1e0a9adb5d230002d3`,
        institutional: `659f67b76c44d3bcd974c4e1`,
        demo: `60d356dd26b7e058ec061ca9`,
        invlinic: `663c37641ed09022b8d9a09e`,
      },
    },
  }

  return config[APP_ID]
}

export const AppConstant = getConfig()